<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text mgr_15">
					Country
				</em>
				<span class="int_type mgr_15">
					<select v-model="country_code" class="tbl_select sm_int">
						<option v-for="country in sortedCountries" v-bind:value="country.code" v-bind:key="country.code">{{ country.name }}</option>
					</select>
				</span>
				<em class="lt_text mgr_15">
					State
				</em>
				<span class="int_type mgr_15">
					<select v-model="state" class="tbl_select sm_int">
						<option v-for="st in states" v-bind:value="st.state" v-bind:key="st.state">{{ st.state }}</option>
					</select>
				</span>
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<a href="javascript:;" class="gray_bt" @click="selectZipcodes()">Search</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_tbl">
				<!-- <h4 class="inner_h4">Zone List</h4> -->
				<div class="fixed-table-container">
					<div class="table-wrapper">
						<table class="list_tbl tbl_pointer">
							<thead>
								<tr>
									<th style="text-align:center;width:10%;"><div class="th-text">Zipcode</div></th>
									<th style="text-align:center;width:10%;"><div class="th-text">State</div></th>
									<th style="text-align:center;width:15%"><div class="th-text">City</div></th>
									<th style="text-align:center;width:10%;"><div class="th-text">Active</div></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="zipcode in zipcodes" v-bind:key="zipcode.zipcode_no" v-bind:class="{ on: zipcode.zipcode_no == selectedZipcode.zipcode_no }" @click="selectRow(zipcode)">
									<td>{{ zipcode.zipcode }}</td>
									<td>{{ zipcode.state }}</td>
									<td>{{ zipcode.city }}</td>
									<td style="text-align:center;">{{ zipcode.active_yn }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ zipcodes.length | commaSeparated }}</div>

				<div class="view_bottom_bt">
					<a href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
				</div>
			</div>

			<div class="right_tbl">
				<h4 class="inner_h4">{{ detailTitle }}</h4>
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:135px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Country</th>
							<td>
								<input type="text" v-model.trim="zipcode.country_code" class="tbl_int sm_int" disabled="true" />
							</td>
						</tr>
						<tr>
							<th>Zipcode</th>
							<td>
								<input type="text" v-model.trim="zipcode.zipcode" ref="zipcode" class="tbl_int sm_int" />
							</td>
						</tr>
						<tr>
							<th>State</th>
							<td><input type="text" v-model.trim="zipcode.state" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th>City</th>
							<td><input type="text" v-model.trim="zipcode.city" class="tbl_int sm_int" /></td>
						</tr>
						<tr>
							<th></th>
							<td>
								<label for="active_yn" style="margin-left:5px;"> <input type="checkbox" id="active_yn" v-model="zipcode.active_yn" true-value="Y" false-value="N" />Active</label>
							</td>
						</tr>
					</tbody>
				</table>

				<div class="view_bottom_bt" style="padding-top:15px;">
					<a href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="submit()">Save</a>
					&nbsp;<a v-if="false" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()">Delete</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectStateList, apiSelectCodeList, apiSelectZipcodeList, apiInsertZipcode, apiUpdateZipcode, apiDeleteZipcode } from '@/api/basicinfo/code.js';
import _ from 'lodash';
import '@/assets/css/table_box.css';

export default {
	data: function() {
		return {
			backUri: '/',
			country_code: null,
			state: null,
			active_yn: 'Y',
			mode: null,

			countries: [],
			states: [],
			zipcodes: [],
			//zoneCharges: [],
			selectedZipcode: {},

			zipcode: {},
		};
	},
	computed: {
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		isValid() {
			if (!this.zipcode.country_code || !this.zipcode) return false;
			else return true;
		},
		isDeletable() {
			if (this.mode == 'detail' && this.selectedZipcode) return true;
			else return false;
		},
		sortedCountries() {
			return _.orderBy(this.countries, 'name', 'asc'); // 오름차순 :: asc
		},
		// sortedCodeTypes() {
		// 	return _.orderBy(this.$codeTypes, 'text', 'asc'); // 오름차순 :: asc
		// },
	},
	watch: {
		country_code: function() {
			//if (oldValue) console.log('data changed from ', oldValue, 'to ', newValue);
			if (this.country_code) this.selectStates();
		},
	},
	components: {},
	methods: {
		async selectCountries() {
			const { data } = await apiSelectCodeList({ code_type: 'CO', active_yn: this.active_yn });
			this.countries = data.codeList;
			this.state = null;
		},
		async selectStates() {
			const { data } = await apiSelectStateList({ country_code: this.country_code });
			this.states = data.stateList;
			this.state = null;
		},
		async selectZipcodes() {
			if (this.country_code == 'US' && !this.state) {
				this.$toast.warning('Select state');
				return;
			}

			const { data } = await apiSelectZipcodeList({ country_code: this.country_code, state: this.state, active_yn: this.active_yn });

			this.zipcodes = data.zipcodeList;
			if (this.zipcodes.length > 0) {
				this.zipcode = this.zipcodes[0];
			} else {
				this.zipcode = {};
			}

			this.mode = 'detail';
		},
		add() {
			this.mode = 'add';
			this.zipcode = {};
			this.zipcode.country_code = this.country_code;
			this.zipcode.state = this.state;
			this.zipcode.active_yn = 'Y';
			this.selectedZipcode = {};
		},
		async submit() {
			if (!this.zipcode.zipcode) {
				this.$toast.error('Empty Zipcode');
				return;
			}
			if (this.country_code == 'US' && !this.zipcode.state) {
				this.$toast.error('Empty State');
				return;
			}
			//console.log(this.zipcode);
			var response;
			if (this.mode == 'add') {
				response = await apiInsertZipcode(this.zipcode);
			} else {
				response = await apiUpdateZipcode(this.zipcode);
			}
			var data = response.data;
			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'add') {
					this.zipcode.zipcode_no = data.zipcode_no;
					//console.log(data);
					this.zipcodes.push(this.zipcode);
				}
				//this.setSelectedZipcode();
				Object.assign(this.selectedZipcode, this.zipcode);
			} else {
				this.$toast.error(data.msg);
			}
			this.mode = 'detail';
		},
		// setSelectedZipcode() {
		// 	this.selectedZipcode.zipcode_no = this.zipcode.zipcode_no;
		// 	this.selectedZipcode.country_code = this.zipcode.country_code;
		// 	this.selectedZipcode.zipcode = this.zipcode.zipcode;
		// 	this.selectedZipcode.state = this.zipcode.state;
		// 	this.selectedZipcode.city = this.zipcode.city;
		// 	this.selectedZipcode.active_yn = this.zipcode.active_yn;
		// },
		async del() {
			if (!this.isDeletable) return;
			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteZipcode(this.zipcode);
				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.selectZipcodes();
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		selectRow(zipcode) {
			this.mode = 'detail';
			this.selectedZipcode = zipcode;

			//console.log(zone);
			this.zipcode = _.cloneDeep(zipcode);
		},
	},
	created() {
		this.backUri = '/';

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_zipcode');
		this.$store.commit('setSubTitle', 'Basic Information -> Zipcode');

		this.selectCountries();
		this.country_code = 'US';
		//this.selectZipcodes();
	},
	mounted() {
		inputSelectOnClick();

		$('.table-wrapper').on('scroll', function() {
			if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
				//var $rows = $('#item_list tbody tr');
				var $rows = $('.list_table tbody tr');
				var lastActiveIndex = $rows.filter('.active:last').index();
				$rows.filter(':lt(' + (lastActiveIndex + 25) + ')').addClass('active');
			}
		});
	},
};
</script>

<style></style>
